import {useEffect, useState} from "react";
import val_api from "../../api/valuation";
import GenericDialog from "../GenericDialog";

const ValuerRequestDetailsForm = (props) => {
    const summaryId = props.summaryId;

    const [categories, setCategories] = useState([]);
    const [propertyTypes, setPropertyTypes] = useState([]);
    const [reportLengths, setReportLengths] = useState([]);
    const [purposes, setPurposes] = useState([]);

    const [category, setCategory] = useState("");
    const [propertyType, setPropertyType] = useState("");
    const [reportLength, setReportLength] = useState("");
    const [purpose, setPurpose] = useState("");
    const [fee, setFee] = useState("");

    const [saveEnabled, setSaveEnabled] = useState(false);
    const [saving, setSaving] = useState(false);

    const [error, setError] = useState("");
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const okButton = [{"text": "OK", "id": "1"}];

    useEffect(() => {
        val_api.getValuationCategories().then(response => {
            setCategories(response.data.types || []);
        }).catch(err => {
            console.log(err);
        });
        val_api.getValuationReportLength().then(response => {
            setReportLengths(response.data.types || []);
        }).catch(err => {
            console.log(err);
        });
        val_api.getValuationPurpose().then(response => {
            setPurposes(response.data.types || []);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const loadDetails = () => {
        if (!summaryId) return;
        val_api.getValuationRequestDetails(summaryId).then(response => {
            const summary = response.data.valuation_summary || {};
            setCategory(summary.category != null ? summary.category : "");
            setPropertyType(summary.property_type != null ? summary.property_type : "");
            setReportLength(summary.report_length_id != null ? summary.report_length_id : "");
            setPurpose(summary.purpose != null ? summary.purpose : "");
            setFee(summary.fee != null ? summary.fee : "");
            setSaveEnabled(false);
        }).catch(err => {
            console.log(err);
        });
    };

    useEffect(() => {
        loadDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryId]);

    useEffect(() => {
        if (category === "") {
            setPropertyTypes([]);
            return;
        }
        val_api.getValuationPropertyTypes(category).then(response => {
            setPropertyTypes(response.data.types || []);
        }).catch(err => {
            console.log(err);
            setPropertyTypes([]);
        });
    }, [category]);

    const handleFieldChange = (setter) => (ev) => {
        setter(ev.target.value);
        setSaveEnabled(true);
    };

    const handleCategoryChange = (ev) => {
        setCategory(ev.target.value);
        setPropertyType("");
        setSaveEnabled(true);
    };

    const handleSave = () => {
        if (!summaryId) return;
        setSaving(true);
        const body = {
            valuation_summary: {
                id: summaryId,
                category: category === "" ? null : parseInt(category),
                property_type: propertyType === "" ? null : parseInt(propertyType),
                report_length_id: reportLength === "" ? null : parseInt(reportLength),
                purpose: purpose === "" ? null : parseInt(purpose),
                fee: fee === "" ? null : fee,
            }
        };
        val_api.saveValuationRequestDetails(body).then(() => {
            setSaveEnabled(false);
        }).catch(err => {
            console.log(err);
            setError("Failed to save the request details");
            setShowErrorDialog(true);
        }).finally(() => {
            setSaving(false);
        });
    };

    return (
        <>
            <div className="valuer-review-info-details-section">
                <div className="valuer-review-status-row">
                    <div className="label">Category</div>
                    <div className="content">
                        <select value={category} onChange={handleCategoryChange}>
                            <option value="" disabled hidden>Select category</option>
                            {categories.map((c, idx) => (
                                <option value={c.id} key={idx}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="valuer-review-status-row">
                    <div className="label">Property type</div>
                    <div className="content">
                        <select value={propertyType} onChange={handleFieldChange(setPropertyType)}
                                disabled={category === ""}>
                            <option value="" disabled hidden>Select property type</option>
                            {propertyTypes.map((pt, idx) => (
                                <option value={pt.id} key={idx}>{pt.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="valuer-review-status-row">
                    <div className="label">Report length</div>
                    <div className="content">
                        <select value={reportLength} onChange={handleFieldChange(setReportLength)}>
                            <option value="" disabled hidden>Select report length</option>
                            {reportLengths.map((rl, idx) => (
                                <option value={rl.id} key={idx}>{rl.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="valuer-review-status-row">
                    <div className="label">Purpose</div>
                    <div className="content">
                        <select value={purpose} onChange={handleFieldChange(setPurpose)}>
                            <option value="" disabled hidden>Select purpose</option>
                            {purposes.map((p, idx) => (
                                <option value={p.id} key={idx}>{p.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="valuer-review-status-row">
                    <div className="label">Fee</div>
                    <div className="content">
                        <input type="text" value={fee} onChange={handleFieldChange(setFee)}
                               placeholder="Fee"/>
                    </div>
                </div>
                <div className="valuer-review-status-row">
                    <div className="label"/>
                    <div className="content right">
                        <button onClick={handleSave} disabled={!saveEnabled || saving}>Save</button>
                    </div>
                </div>
            </div>
            {showErrorDialog
                ? <GenericDialog title="Request details" text={error} buttons={okButton}
                                 result={() => setShowErrorDialog(false)}/>
                : null}
        </>
    );
};

export default ValuerRequestDetailsForm;
